<template>
  <div>
    <div>
      <SectionHeader
        :text="$t('history.membersText')"
        :subtext="$t('history.membersSubText')"
        :back-text="$t('history.membersBack')"
      />
      <transition name="load">
        <h2 v-if="!data">
          <Loading />
        </h2>
        <div v-if="data" id="members-content">
          <div class="letters">
            <div class="letters-list">
              <a
                v-smooth-scroll="{ duration: 1000 }"
                :href="'#' + letter.letter"
                :letter="letter.letter"
                v-for="letter in data"
                :key="letter.letter"
                >{{ letter.letter }}</a
              >
            </div>
            <section
              :key="letter.letter"
              :id="letter.letter"
              v-for="letter in data"
              class="letter-wrapper"
            >
              <div class="letter">{{ letter.letter }}</div>
              <div class="letter-content">
                <ul>
                  <li v-for="person in letter.persons" :key="person.name">
                    <div>{{ person.name }}</div>
                    <div>{{ person.position }}</div>
                  </li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";
import SectionHeader from "../SectionHeader";

export default {
  name: "FirstPage",
  components: {
    Loading,
    SectionHeader
  },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http.get("members/").then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
.load-enter-active,
.load-leave-active {
  transition: 1s;
}

.load-leave-active {
  position: absolute;
}

.load-enter {
  opacity: 0;
}

.load-leave-to {
  opacity: 0;
}

.title {
  font-size: 38px;
}

.letters-list {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  margin-top: -25px;
  margin-bottom: 30px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  flex-wrap: wrap;
}

.letters-list a {
  margin-right: 7px;
  font-family: Roboto, sans-serif;
  color: #a5a5a5;
  font-size: 1.7em;
  line-height: 2em;
  font-weight: 300;
  text-decoration: none;
  width: 50px;
}

.letter-wrapper {
  display: flex;
  flex-direction: row;
}

.letter {
  width: 15%;
  font-size: 4em;
  color: black;
  font-weight: 700;
}

.letter-content {
  width: 100%;
  margin-bottom: 50px;
}

ul {
  list-style-type: none;
  padding-left: 0;
}

ul li {
  position: relative;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 26px;
  float: left;
  border-top: 1px solid #ddd;
  font-family: "Fira Sans", sans-serif;
  color: #3d5262;
  font-size: 1.15em;
  font-weight: 500;
}

ul li div {
  display: inline-block;
  width: 60%;
}

ul li div:nth-child(2) {
  color: #a09b9b;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  width: 40%;
}
</style>

<style></style>
